export default {
    namespaced: true,

    state: {
        loading: false
    },

    mutations: {
        SET_LOADING(state, value) {
            console.log('🔥 MUTATION SET_LOADING:', value)
            state.loading = value
        }
    },

    actions: {
        showLoader({ commit }) {
            commit('SET_LOADING', true)
        },
        hideLoader({ commit }) {
            commit('SET_LOADING', false)
        }
    }
}
